'use strict';
/**
 * Protobuf interface
 * from go-ipfs/pin/internal/pb/header.proto
 */

module.exports = "\n  syntax = \"proto2\";\n\n  package ipfs.pin;\n\n  option go_package = \"pb\";\n\n  message Set {\n    optional uint32 version = 1;\n    optional uint32 fanout = 2;\n    optional fixed32 seed = 3;\n  }\n";